import { useEffect } from 'react';

import { useChoreographerContext } from '../create-placement-component/providers/stable-choreographer';

export const useDisableChoreographer = (): void => {
	const { setChoreographerEnabled } = useChoreographerContext();

	useEffect(() => {
		setChoreographerEnabled(false);
	}, []);
};
